const Categories = [
  {
    id: 1,
    image:
      "https://res.cloudinary.com/miguelgallardof/image/upload/v1674763827/Torres%20Construction/Fotos/01_umqnpn.jpg",
    category: "renovations",
  },
  {
    id: 2,
    image:
      "https://res.cloudinary.com/miguelgallardof/image/upload/v1681794287/Torres%20Construction/Fotos/02_uaantm.jpg",
    category: "tiles",
  },
  {
    id: 3,
    image:
      "https://res.cloudinary.com/miguelgallardof/image/upload/v1675583157/Torres%20Construction/Fotos/03_zir1oo.jpg",
    category: "painting",
  },
  {
    id: 4,
    image:
      "https://res.cloudinary.com/miguelgallardof/image/upload/v1674763844/Torres%20Construction/Fotos/04_jexgjw.jpg",
    category: "renovations",
  },

  {
    id: 5,
    image:
      "https://res.cloudinary.com/miguelgallardof/image/upload/v1681794287/Torres%20Construction/Fotos/05_cejrqh.jpg",
    category: "painting",
  },
  {
    id: 6,
    image:
      "https://res.cloudinary.com/miguelgallardof/image/upload/v1674763974/Torres%20Construction/Fotos/06_iixe80.jpg",
    category: "renovations",
  },
  {
    id: 7,
    image:
      "https://res.cloudinary.com/miguelgallardof/image/upload/v1681794920/Torres%20Construction/Fotos/07_q7cjij.jpg",
    category: "tiles",
  },
  {
    id: 8,
    image:
      "https://res.cloudinary.com/miguelgallardof/image/upload/v1675583237/Torres%20Construction/Fotos/08_lhlqvx.jpg",
    category: "tiles",
  },
  {
    id: 9,
    image:
      "https://res.cloudinary.com/miguelgallardof/image/upload/v1681794287/Torres%20Construction/Fotos/09_g9evrf.jpg",
    category: "carpentry",
  },
  {
    id: 10,
    image:
      "https://res.cloudinary.com/miguelgallardof/image/upload/v1681794287/Torres%20Construction/Fotos/10_enjj5i.jpg",
    category: "carpentry",
  },
  {
    id: 11,
    image:
      "https://res.cloudinary.com/miguelgallardof/image/upload/v1681794287/Torres%20Construction/Fotos/11_rzfcfc.jpg",
    category: "tiles",
  },
  {
    id: 12,
    image:
      "https://res.cloudinary.com/miguelgallardof/image/upload/v1674764007/Torres%20Construction/Fotos/12_lwlwrs.jpg",
    category: "carpentry",
  },
  {
    id: 13,
    image:
      "https://res.cloudinary.com/miguelgallardof/image/upload/v1674764013/Torres%20Construction/Fotos/13_o73yao.jpg",
    category: "painting",
  },
  {
    id: 14,
    image:
      "https://res.cloudinary.com/miguelgallardof/image/upload/v1674764017/Torres%20Construction/Fotos/14_gwe7il.jpg",
    category: "renovations",
  },
  {
    id: 15,
    image:
      "https://res.cloudinary.com/miguelgallardof/image/upload/v1681794288/Torres%20Construction/Fotos/15_yxxwxf.jpg",
    category: "carpentry",
  },
  {
    id: 16,
    image:
      "https://res.cloudinary.com/miguelgallardof/image/upload/v1674764026/Torres%20Construction/Fotos/16_pwrr7o.jpg",
    category: "renovations",
  },
  {
    id: 17,
    image:
      "https://res.cloudinary.com/miguelgallardof/image/upload/v1674764028/Torres%20Construction/Fotos/17_e3y6w7.jpg",
    category: "drywall",
  },
  {
    id: 18,
    image:
      "https://res.cloudinary.com/miguelgallardof/image/upload/v1681794288/Torres%20Construction/Fotos/18_k45dht.jpg",
    category: "tiles",
  },
  {
    id: 19,
    image:
      "https://res.cloudinary.com/miguelgallardof/image/upload/v1675583238/Torres%20Construction/Fotos/19_tkiwg5.jpg",
    category: "renovations",
  },
  {
    id: 20,
    image:
      "https://res.cloudinary.com/miguelgallardof/image/upload/v1675583254/Torres%20Construction/Fotos/21_fw7jqx",
    category: "drywall",
  },
  {
    id: 21,
    image:
      "https://res.cloudinary.com/miguelgallardof/image/upload/v1681882033/Torres%20Construction/Fotos/21_fw7jqx.jpg",
    category: "renovations",
  },
  {
    id: 22,
    image:
      "https://res.cloudinary.com/miguelgallardof/image/upload/v1675583254/Torres%20Construction/Fotos/22_jmqoo8.jpg",
    category: "renovations",
  },
  {
    id: 23,
    image:
      "https://res.cloudinary.com/miguelgallardof/image/upload/v1681882033/Torres%20Construction/Fotos/23_o53p3s.jpg",
    category: "painting",
  },
  {
    id: 24,
    image:
      "https://res.cloudinary.com/miguelgallardof/image/upload/v1675583255/Torres%20Construction/Fotos/24_okyffo.jpg",
    category: "carpentry",
  },
  {
    id: 25,
    image:
      "https://res.cloudinary.com/miguelgallardof/image/upload/v1675583255/Torres%20Construction/Fotos/25_bsvji3.jpg",
    category: "drywall",
  },
  {
    id: 26,
    image:
      "https://res.cloudinary.com/miguelgallardof/image/upload/v1675583255/Torres%20Construction/Fotos/26_ga8dsm.jpg",
    category: "painting",
  },
  {
    id: 27,
    image:
      "https://res.cloudinary.com/miguelgallardof/image/upload/v1675583255/Torres%20Construction/Fotos/27_e4aobx.jpg",
    category: "painting",
  },
  {
    id: 28,
    image:
      "https://res.cloudinary.com/miguelgallardof/image/upload/v1675583255/Torres%20Construction/Fotos/28_fwa1dh.jpg",
    category: "drywall",
  },
  {
    id: 29,
    image:
      "https://res.cloudinary.com/miguelgallardof/image/upload/v1675654485/Torres%20Construction/Fotos/29_uhh6yr.jpg",
    category: "carpentry",
  },
  {
    id: 30,
    image:
      "https://res.cloudinary.com/miguelgallardof/image/upload/v1679204352/Torres%20Construction/Fotos/30_j8zfpp.jpg",
    category: "painting",
  },
  {
    id: 31,
    image:
      "https://res.cloudinary.com/miguelgallardof/image/upload/v1675583256/Torres%20Construction/Fotos/31_qakd8c.jpg",
    category: "carpentry",
  },
  {
    id: 32,
    image:
      "https://res.cloudinary.com/miguelgallardof/image/upload/v1675583256/Torres%20Construction/Fotos/32_hec2vw.jpg",
    category: "drywall",
  },
  {
    id: 33,
    image:
      "https://res.cloudinary.com/miguelgallardof/image/upload/v1675583256/Torres%20Construction/Fotos/33_cvovfa.jpg",
    category: "painting",
  },
  {
    id: 34,
    image:
      "https://res.cloudinary.com/miguelgallardof/image/upload/v1681794288/Torres%20Construction/Fotos/34_yueu85.jpg",
    category: "tiles",
  },
  {
    id: 35,
    image:
      "https://res.cloudinary.com/miguelgallardof/image/upload/v1675583251/Torres%20Construction/Fotos/35_rthynb.jpg",
    category: "drywall",
  },
  {
    id: 36,
    image:
      "https://res.cloudinary.com/miguelgallardof/image/upload/v1675583251/Torres%20Construction/Fotos/36_iv6nzv.jpg",
    category: "tiles",
  },
  {
    id: 37,
    image:
      "https://res.cloudinary.com/miguelgallardof/image/upload/v1681794287/Torres%20Construction/Fotos/37_cwddbb.jpg",
    category: "drywall",
  },
  {
    id: 38,
    image:
      "https://res.cloudinary.com/miguelgallardof/image/upload/v1675583251/Torres%20Construction/Fotos/38_i0rfpu.jpg",
    category: "drywall",
  },
  {
    id: 39,
    image:
      "https://res.cloudinary.com/miguelgallardof/image/upload/v1675583251/Torres%20Construction/Fotos/39_emxcj8.jpg",
    category: "tiles",
  },
  {
    id: 40,
    image:
      "https://res.cloudinary.com/miguelgallardof/image/upload/v1681794288/Torres%20Construction/Fotos/40_nubthh.jpg",
    category: "carpentry",
  },
];

export default Categories;
